export let DomainAssignmentState = /*#__PURE__*/function (DomainAssignmentState) {
  DomainAssignmentState["NONE"] = "NONE";
  DomainAssignmentState["ASSIGNED"] = "ASSIGNED";
  DomainAssignmentState["UNASSIGNED"] = "UNASSIGNED";
  return DomainAssignmentState;
}({});

/**
 * asciiDomain - the root domain (not including subdomain) in ascii, this is the UUID for DB persisting and refetching
 * fullAsciiDomain - the entire input in ascii (including subdomain)
 */

export let DomainNameErrors = /*#__PURE__*/function (DomainNameErrors) {
  DomainNameErrors["INVALID_DOMAIN_NAME"] = "INVALID_DOMAIN_NAME";
  DomainNameErrors["DOMAIN_TOO_SHORT"] = "DOMAIN_TOO_SHORT";
  DomainNameErrors["DOMAIN_TOO_LONG"] = "DOMAIN_TOO_LONG";
  DomainNameErrors["INVALID_DASH_USAGE"] = "INVALID_DASH_USAGE";
  DomainNameErrors["LABEL_INVALID_CHARS"] = "LABEL_INVALID_CHARS";
  DomainNameErrors["TWO_CONSECUTIVE_DOTS"] = "TWO_CONSECUTIVE_DOTS";
  DomainNameErrors["OFAC_TLD"] = "OFAC_TLD";
  DomainNameErrors["GENERAL_ERROR"] = "GENERAL_ERROR";
  return DomainNameErrors;
}({});
export let DomainSearchError = /*#__PURE__*/function (DomainSearchError) {
  DomainSearchError["EXTERNAL_VIEWER_POINTING_DOMAIN"] = "externalViewerPointingDomain";
  DomainSearchError["EXTERNAL_VIEWER_SUBDOMAIN_NOT_ALLOWED"] = "externalViewerSubdomainNotAllowed";
  DomainSearchError["DOMAIN_HAS_NON_ASCII_CHARS"] = "domainHasNonAsciiChars";
  DomainSearchError["DOMAIN_TAKEN_IN_WIX"] = "domainTakenInWix";
  DomainSearchError["CANNOT_ASSIGN_TO_SHARED_SITE"] = "cannotAssignToSharedSite";
  DomainSearchError["NO_PERMISSIONS_TO_PURCHASE"] = "noPermissionsToPurchase";
  DomainSearchError["NO_PERMISSIONS_TO_CONNECT"] = "noPermissionsToConnect";
  DomainSearchError["LANGUAGE_CODE_SUBDOMAIN"] = "languageCodeSubdomain";
  DomainSearchError["NOT_SUPPORTED_TLD"] = "notSupportedTld";
  DomainSearchError["ALREADY_ASSIGNED_TO_THIS_SITE"] = "alreadyAssignedToThisSite";
  DomainSearchError["ALREADY_ASSIGNED"] = "alreadyAssigned";
  DomainSearchError["TRANSFER_IN_LOCKED_BY_PROVIDER"] = "transferInLockedByProvider";
  DomainSearchError["HAS_PENDING_TRANSFER_IN_REQUEST"] = "hasPendingTransferInRequest";
  DomainSearchError["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
  DomainSearchError["SERVICE_ERROR"] = "SERVICE_ERROR";
  return DomainSearchError;
}({});
export let DomainAvailabilityStatus = /*#__PURE__*/function (DomainAvailabilityStatus) {
  DomainAvailabilityStatus["AVAILABLE_FOR_PURCHASE"] = "AVAILABLE_FOR_PURCHASE";
  DomainAvailabilityStatus["CAN_ASSIGN_TO_SITE"] = "CAN_ASSIGN_TO_SITE";
  DomainAvailabilityStatus["ALREADY_ASSIGNED_TO_THIS_SITE"] = "ALREADY_ASSIGNED_TO_THIS_SITE";
  DomainAvailabilityStatus["CAN_TRANSFER_TO_ACCOUNT"] = "CAN_TRANSFER_TO_ACCOUNT";
  DomainAvailabilityStatus["NOT_SUPPORTED_TLD"] = "NOT_SUPPORTED_TLD";
  DomainAvailabilityStatus["DOMAIN_IN_ANOTHER_WIX_ACCOUNT"] = "DOMAIN_IN_ANOTHER_WIX_ACCOUNT";
  DomainAvailabilityStatus["OWNED_OUTSIDE_OF_WIX"] = "OWNED_OUTSIDE_OF_WIX";
  DomainAvailabilityStatus["INVALID_DOMAIN"] = "INVALID_DOMAIN";
  return DomainAvailabilityStatus;
}({});
export let DomainAvailabilityResolvers = /*#__PURE__*/function (DomainAvailabilityResolvers) {
  DomainAvailabilityResolvers["availableWW"] = "availableWW";
  DomainAvailabilityResolvers["tldNotSupportedWW"] = "tldNotSupportedWW";
  DomainAvailabilityResolvers["tldNotSupportedInWix"] = "tldNotSupportedInWix";
  DomainAvailabilityResolvers["isKnownToWix"] = "isKnownToWix";
  DomainAvailabilityResolvers["domainAndSiteInSameAccount"] = "domainAndSiteInSameAccount";
  DomainAvailabilityResolvers["domainInUserAccount"] = "domainInUserAccount";
  DomainAvailabilityResolvers["domainPurchasedElsewhere"] = "domainPurchasedElsewhere";
  return DomainAvailabilityResolvers;
}({});
export let CanPurchaseDomainErrors = /*#__PURE__*/function (CanPurchaseDomainErrors) {
  CanPurchaseDomainErrors["DOMAIN_HAS_NON_ASCII_CHARS"] = "domainHasNonAsciiChars";
  CanPurchaseDomainErrors["NOT_SUPPORTED_TLD"] = "notSupportedTld";
  CanPurchaseDomainErrors["NOT_AVAILABLE"] = "notAvailable";
  return CanPurchaseDomainErrors;
}({});
export let CanPurchaseDomainSuiteErrors = /*#__PURE__*/function (CanPurchaseDomainSuiteErrors) {
  CanPurchaseDomainSuiteErrors["DOMAIN_HAS_NON_ASCII_CHARS"] = "domainHasNonAsciiChars";
  CanPurchaseDomainSuiteErrors["NOT_SUPPORTED_TLD"] = "notSupportedTld";
  CanPurchaseDomainSuiteErrors["NOT_SUPPORTED_TLD_REGIONAL"] = "notSupportedTldRegional";
  CanPurchaseDomainSuiteErrors["NOT_AVAILABLE"] = "notAvailable";
  return CanPurchaseDomainSuiteErrors;
}({});
export let CheckDomainIsTakenErrors = /*#__PURE__*/function (CheckDomainIsTakenErrors) {
  CheckDomainIsTakenErrors["NOT_SUPPORTED_TLD"] = "notSupportedTld";
  CheckDomainIsTakenErrors["NOT_SUPPORTED_TLD_REGIONAL"] = "notSupportedTldRegional";
  return CheckDomainIsTakenErrors;
}({});
export let CanConnectOrBindSuiteErrors = /*#__PURE__*/function (CanConnectOrBindSuiteErrors) {
  CanConnectOrBindSuiteErrors["DOMAIN_TAKEN_IN_WIX"] = "domainTakenInWix";
  CanConnectOrBindSuiteErrors["UNAUTHORIZED"] = "unauthorized";
  CanConnectOrBindSuiteErrors["CANNOT_ASSIGN_TO_SHARED_SITE"] = "cannotAssignToSharedSite";
  CanConnectOrBindSuiteErrors["LANGUAGE_CODE_SUBDOMAIN"] = "languageCodeSubdomain";
  CanConnectOrBindSuiteErrors["ALREADY_ASSIGNED_TO_THIS_SITE"] = "alreadyAssignedToThisSite";
  CanConnectOrBindSuiteErrors["FLOATING_DOMAIN"] = "floatingDomain";
  CanConnectOrBindSuiteErrors["SUBDOMAIN_ALREADY_ASSIGNED"] = "subdomainAlreadyAssigned";
  CanConnectOrBindSuiteErrors["ALREADY_ASSIGNED"] = "alreadyAssigned";
  CanConnectOrBindSuiteErrors["ROOT_DOMAIN_IS_CONNECTED_BY_POINTING"] = "rootDomainIsConnectedByPointing";
  CanConnectOrBindSuiteErrors["SUBDOMAIN_ROOT_IS_CONNECTED_BY_DNS"] = "subdomainRootIsConnectedByDns";
  CanConnectOrBindSuiteErrors["SUBDOMAIN_ROOT_IS_REGISTERED"] = "subdomainRootIsRegistered";
  CanConnectOrBindSuiteErrors["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
  return CanConnectOrBindSuiteErrors;
}({});
export let CanConnectOrBindErrors = /*#__PURE__*/function (CanConnectOrBindErrors) {
  CanConnectOrBindErrors["DOMAIN_TAKEN_IN_WIX"] = "domainTakenInWix";
  CanConnectOrBindErrors["CANNOT_ASSIGN_TO_SHARED_SITE"] = "cannotAssignToSharedSite";
  CanConnectOrBindErrors["LANGUAGE_CODE_SUBDOMAIN"] = "languageCodeSubdomain";
  CanConnectOrBindErrors["ALREADY_ASSIGNED_TO_THIS_SITE"] = "alreadyAssignedToThisSite";
  CanConnectOrBindErrors["ALREADY_ASSIGNED"] = "alreadyAssigned";
  CanConnectOrBindErrors["ROOT_DOMAIN_IS_CONNECTED_BY_POINTING"] = "rootDomainIsConnectedByPointing";
  CanConnectOrBindErrors["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
  return CanConnectOrBindErrors;
}({});
//# sourceMappingURL=domainSearch.js.map